import type { CanHolder } from "../../lib/access";
import type { IncidentStatus, ReopenIncidentRequest } from "./api";
import { canReopen } from "./permissions";

/** F-018: the reopen Begruendung must carry at least 10 characters. */
export const MIN_REOPEN_REASON_CHARS = 10;

/**
 * GR-007: from the second reopen onward the detail page shows the escalation
 * hint addressed at Manager/Geschaeftsfuehrung (repeated reopening signals a
 * structural problem).
 */
export const REOPEN_ESCALATION_THRESHOLD = 2;

/** Submit-enable check for the reopen dialog (min length after trim). */
export function isReopenReasonValid(reason: string): boolean {
  return reason.trim().length >= MIN_REOPEN_REASON_CHARS;
}

/**
 * The header action shows only on a CLOSED incident whose `can` holds
 * `incident.reopen` (its Owner, or Admin). The server re-checks both
 * (ADR-API-09).
 */
export function isReopenActionVisible(status: IncidentStatus, incident: CanHolder): boolean {
  return status === "abgeschlossen" && canReopen(incident);
}

/**
 * Build the POST body. The Admin-Korrektur flag (does not count against the
 * GR-007 limit) travels only when the viewer actually holds the admin role -
 * the server 403s it otherwise.
 */
export function buildReopenRequest(
  reason: string,
  adminCorrection: boolean,
  isAdmin: boolean,
): ReopenIncidentRequest {
  const body: ReopenIncidentRequest = { reason: reason.trim() };
  if (isAdmin && adminCorrection) body.adminCorrection = true;
  return body;
}

/** True once the GR-007 escalation banner should render (reopenCount >= 2). */
export function showsReopenEscalation(reopenCount: number): boolean {
  return reopenCount >= REOPEN_ESCALATION_THRESHOLD;
}
